import { render, staticRenderFns } from "./SourceCode.vue?vue&type=template&id=4dcb86cc&scoped=true&"
import script from "./SourceCode.vue?vue&type=script&lang=js&"
export * from "./SourceCode.vue?vue&type=script&lang=js&"
import style0 from "./SourceCode.vue?vue&type=style&index=0&id=4dcb86cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dcb86cc",
  null
  
)

export default component.exports